<div
	class="c-portlet-table o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary r11-datatable {{ sectionclass }}"
	style="position: relative;"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet__header">
		<div class="o-stack__cel">
			<div class="card-title primary-color">
				{{ sectiontitle }}
				<span *ngIf="tableConfig.enableDownload && hasData" class="datatable-icon">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon-table"
						(click)="downloadCSV($event)"
						target="_blank"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</div>
		</div>
	</div>
	<div class="analytics-portlet-content-table" style="padding: 0%;">
		<ngx-datatable
			style="height: 100%;"
			class="v5datatable"
			[columns]="dataTableObj.columns"
			[rows]="dataTableObj.data"
			[sortType]="'single'"
			[cssClasses]="cssClasses"
			[columnMode]="'force'"
			[headerHeight]="50"
			[footerHeight]="footerHeight"
			[rowHeight]="rowHeight"
			[limit]="dataTableObj.limit"
			[reorderable]="reorderable"
			(activate)="onUserEvent($event)"
			[scrollbarV]="isVerticalScrollable"
			(page)="onPageChange($event)"
		>
			<ng-template ngFor let-column [ngForOf]="dataTableObj.columns">
				<ngx-datatable-column
					name="{{ column.name }}"
					prop="{{ column.prop }}"
					[resizeable]="false"
					[sortable]="true"
					[cellClass]="column.cellClass"
					[headerClass]="column.headerClass"
					[comparator]="column.comparator"
				>
					<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
						<span
							[innerHTML]="colHeader.name"
							(click)="sort()"
							style="cursor: pointer;"
							*ngIf="!column.columnHasTooltip; else elseBlock"
						>
						</span>

						<ng-template #elseBlock>
							<span style="cursor: pointer;">
								<span
									[innerHTML]="colHeader.name"
									(click)="sort()"
									appTooltip
									title="Tooltip"
									[title]="column.columnTooltip"
									data-size="big"
									[options]="tooltipOptions"
								>
								</span>
							</span>
						</ng-template>
					</ng-template>

					<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
						<div class="network-div" *ngIf="column.name == 'Platform' || column.name === 'Placement'">
							<div
								class="network-logo"
								*ngIf="row.favicon_url || row.logo_path"
								[ngStyle]="{ 'background-image': 'url(' + row['logo_path'] + ')' }"
							></div>
							<div class="network-name" [title]="row.platform_name">{{ row['platform_name'] }}</div>
						</div>
						<div class="place-div" *ngIf="column.columnDisplayImage">
							<div
								class="place-logo"
								*ngIf="row.favicon_url"
								[ngStyle]="{ 'background-image': 'url(' + row['favicon_url'] + ')' }"
							></div>
							<div class="place-name" [title]="row.place">{{ row['place'] }}</div>
						</div>
						<div
							*ngIf="!column.columnDisplayImage && column.name !== 'Platform' && column.name !== 'Placement'"
							[title]="row[column.prop]"
						>
							{{ row[column.prop] }}
						</div>
					</ng-template>
				</ngx-datatable-column>
			</ng-template>
		</ngx-datatable>
	</div>
</div>
